import { SwiperItem } from '../../libs/gin-tonic/components/swiper';

export class SlideshowComponent {
	constructor(private element: HTMLElement) {
		new SwiperItem(element, {
			slidesPerView: 1,
			spacing: 90,
			loop: true,
			navigation: {
				nextEl: '.swiper-next',
				prevEl: '.swiper-prev',
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				1200: {
					slidesPerView: 1,
				},
			}
		});
	}
}
